module.exports = "/_next/static/images/salon_manager_logo-880ba9dfeaf805248e07461f82d75ea1.svg";